export const getSearchScreenType = () => 'search';
